import styled from "@emotion/styled";
import { Button } from "@mui/material";

const WrapperRoot = styled.div`
  max-width: 780px;
  position: relative;

  margin: 52px auto 0;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin: 93px auto 0;
  }
`;

const Title = styled.h2`
  margin-bottom: 20px;

  font-size: 22px;
  font-weight: ${p => p.theme.fontWeight.medium};
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.secondary.title};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: 40px;

    font-size: ${p => p.theme.fontSizes.xxl};
    font-weight: ${p => p.theme.fontWeight.semiBold};
  }
`;

const List = styled.ul`
  height: 153px;
  padding: 0;
  margin: 0;

  list-style: none;
  overflow-y: auto;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    height: 232px;
  }
`;

const Item = styled.li`
  &:not(:first-of-type) {
    margin-top: 14px;

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      margin-top: 18px;
    }
  }
`;

const ButtonStyled = styled(Button)`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  position: relative;

  &:hover,
  &:focus {
    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
      height: 2px;
      background-color: ${({ theme }) =>
        theme.colors.secondary.popular_queries};
      transition:
        background-color 0.3s ease,
        transform 0.3s ease;
      transform: scaleX(1);
    }
  }

  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.secondary.popular_queries};
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
  }
`;

const Text = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.secondary.popular_queries};

  cursor: pointer;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
  }
`;

export { WrapperRoot, Title, List, Item, ButtonStyled, Text };
